import Proptypes from 'prop-types'
import Lock from 'components/Lock'
import Riddle from 'components/Riddle'
import { isPartVisible } from 'utils/displayByDateAndTime'
import Dispatcher from 'components/Dispatcher'

export const PartKeyCode = ({ part, themeInfos }) => {
  if (!isPartVisible(part)) return null
  switch (part.type) {
    case 'Dispatcher':
      return <Dispatcher part={part} themeInfos={themeInfos} />
    case 'Lock':
      return <Lock part={part} themeInfos={themeInfos}/>
    case 'Riddle':
      return <Riddle part={part} themeInfos={themeInfos}/>
    case 'LockCancel':
    case 'LockPage':
    case 'RiddleCancel':
    case 'RiddlePage':
    default:
      return null
  }
}

PartKeyCode.propTypes = {
  part: Proptypes.object,
  themeInfos: Proptypes.object,
}

export default PartKeyCode
